export const pastExperience = [
  {
    name: 'Swizel',
    role: ['Contract Based Frontend developer'],
    duration: 'November 2021 - June 2022',
  },
  {
    name: 'IgrowAfrika',
    role: ['Front web developer'],
    duration: 'April 2022 - Present',
  },
  {
    name: 'DumbMeta',
    role: ['Project lead', 'Writer', 'Web developer'],
    duration: 'November 2021 - March 2022',
  },
  {
    name: 'Iceztech',
    role: ['Intern', 'Educator', 'Frontend lead'],
    duration: 'February 2021 - January 2022',
  },
];

export default pastExperience;
